// @ts-nocheck
import componentsReducer, {
    BunzlComponentsActions,
} from "@store/Framework/Store/Bunzl/Components/ComponentsReducer";
// import pagesReducer, { BunzlPagesActions } from "@store/Framework/Store/Bunzl/Pages/PagesReducer"; // Bunzl Custom Code
import "@toolkit/Framework/Store";
import { combineReducers, Dispatch } from "redux";

/* Bunzl Custom Code - Start */
import pagesReducer, { BunzlPagesActions } from "@store/Framework/Store/Bunzl/Pages/PagesReducer";
import { useDispatch } from "react-redux";
/* Bunzl Custom Code - End */

const bunzlReducers = {
    components: componentsReducer,
    pages: pagesReducer,
};

export type BunzlActions = BunzlComponentsActions | BunzlPagesActions;
export default combineReducers(bunzlReducers);

export const useBunzlDispatch = () => useDispatch<Dispatch<BunzlActions>>();
